<div class="flex">
    @if (
        (this.showLineItemDiscountBreakdownSig() ||
            this.modelSig()?.priceSource !== PriceSourceType.MANUALPRICE) &&
        this.modelSig()?.type !== DocumentLineItemType.TEXT &&
        this.modelSig()?.itemPrice
    ) {
        <i
            class="fa fa-info-circle text-slate-300 mt-1"
            [pTooltip]="
                this.showLineItemDiscountBreakdownSig() ||
                this.modelSig()?.priceSource !== PriceSourceType.MANUALPRICE
                    ? priceTooltipTemplate
                    : null
            "
            [tooltipStyleClass]="'!w-[250px]'"
        ></i
        >&nbsp;
    }
    @if (this.modelSig()?.type !== DocumentLineItemType.TEXT) {
        <span
            [class]="
                'ml-auto ' +
                (this.modelSig()?.priceSource == PriceSourceType.MANUALPRICE
                    ? 'text-orange-400'
                    : '')
            "
        >
            {{ this.itemPriceSig() }}
        </span>
    }
</div>

<ng-template #priceTooltipTemplate>
    <div class="flex flex-col">
        <h2 class="text-center">{{ 'document-line-item.price-overview' | translate }}</h2>
        <hr />
        <div>
            <b>{{ 'common.item-price' | translate }}</b>
        </div>
        <div *ngIf="getPriceOrigin(modelSig().priceSource)">
            {{ this.getPriceOrigin(modelSig().priceSource) }}
            {{
                this.modelSig()?.priceListBulkQuantity
                    ? ' (' +
                      ('common.from' | translate) +
                      ' ' +
                      this.modelSig()?.priceListBulkQuantity +
                      ' ' +
                      (this.modelSig()?.unitShortForm ?? this.modelSig()?.unitIdentifier ?? '') +
                      ')'
                    : ''
            }}
        </div>
        <div class="ml-auto">
            <b>
                {{ this.itemPriceSig() }}
            </b>
        </div>
        @if (this.showLineItemDiscountBreakdownSig() && this.modelSig()?.discountPercentage) {
            <div class="flex flex-col">
                <div>
                    <span> {{ 'common.discount1' | translate }} </span>
                    <span>({{ this.modelSig()?.discountPercentage }}%):</span>
                </div>
                <div class="ml-auto">
                    -
                    {{
                        this.modelSig()?.itemPrice * (this.modelSig()?.discountPercentage / 100)
                            | decimalPlacesCustom: '0.01'
                    }}
                </div>
            </div>
        }

        @if (this.showLineItemDiscountBreakdownSig() && this.modelSig()?.discountPercentage2) {
            <div class="flex flex-col">
                <div>
                    <span> {{ 'common.discount2' | translate }} </span>
                    <span>({{ this.modelSig()?.discountPercentage2 }}%):</span>
                </div>
                <div class="ml-auto">
                    -
                    @if (this.modelSig()?.discountPercentage) {
                        {{
                            this.modelSig()?.itemPrice *
                                (1 - this.modelSig()?.discountPercentage / 100) *
                                (this.modelSig()?.discountPercentage2 / 100)
                                | decimalPlacesCustom: '0.01'
                        }}
                    } @else {
                        {{
                            this.modelSig()?.itemPrice *
                                (this.modelSig()?.discountPercentage2 / 100)
                                | decimalPlacesCustom: '0.01'
                        }}
                    }
                </div>
            </div>
            <hr />
            <div>
                <b>
                    {{ 'document-line-item.final-price' | translate }}
                </b>
            </div>
            <div>
                {{
                    ('common.per' | translate) +
                        ' ' +
                        (this.modelSig()?.priceUnit ?? '') +
                        ' ' +
                        (this.modelSig()?.unitShortForm ?? this.modelSig()?.unitIdentifier ?? ('common.unit-units' | translate))
                }}
            </div>
            <div class="flex ml-auto">
                <b>
                    @if (
                        this.modelSig()?.discountPercentage && this.modelSig()?.discountPercentage2
                    ) {
                        {{
                            this.modelSig()?.itemPrice *
                                (1 - this.modelSig()?.discountPercentage / 100) *
                                (1 - this.modelSig()?.discountPercentage2 / 100)
                                | decimalPlacesCustom: '0.01'
                        }}
                    } @else if (
                        this.modelSig()?.discountPercentage && !this.modelSig()?.discountPercentage2
                    ) {
                        {{
                            this.modelSig()?.itemPrice *
                                (1 - this.modelSig()?.discountPercentage / 100)
                                | decimalPlacesCustom: '0.01'
                        }}
                    } @else if (
                        !this.modelSig()?.discountPercentage && this.modelSig()?.discountPercentage2
                    ) {
                        {{
                            this.modelSig()?.itemPrice *
                                (1 - this.modelSig()?.discountPercentage2 / 100)
                                | decimalPlacesCustom: '0.01'
                        }}
                    }
                </b>
            </div>
        }
    </div>
</ng-template>
